import { render, staticRenderFns } from "./SolutionDescriptionWrapper.vue?vue&type=template&id=2d6e932a&scoped=true"
import script from "./SolutionDescriptionWrapper.vue?vue&type=script&lang=js"
export * from "./SolutionDescriptionWrapper.vue?vue&type=script&lang=js"
import style0 from "./SolutionDescriptionWrapper.vue?vue&type=style&index=0&id=2d6e932a&prod&lang=css"
import style1 from "./SolutionDescriptionWrapper.vue?vue&type=style&index=1&id=2d6e932a&prod&lang=scss&scoped=true"
import style2 from "./SolutionDescriptionWrapper.vue?vue&type=style&index=2&id=2d6e932a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d6e932a",
  null
  
)

export default component.exports